module.exports = __webpack_public_path__ + "img/hello_home_page_4.a1eb2d89.png";